var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenCloseNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 48,
    height: 48,
    style: {
      color: "#A2AFC3",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8403,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1024,
    width: 1024,
    height: 1024,
    rx: 4096,
    transform: "rotate(-90 0 1024)",
    fill: "#DEE3E9",
    fillOpacity: 0.4,
    x: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.677538 898.993231a39.384615 39.384615 0 0 1-27.844923-67.229539L866.776615 97.122462a39.384615 39.384615 0 0 1 55.689847 55.689846L199.522462 887.453538a39.384615 39.384615 0 0 1-27.844924 11.539693z",
    fill: "rgb(243, 247, 255)",
    "p-id": 8404,
    transform: "scale(0.55) translate(410 460)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M755.830154 906.043077H256.945231a35.446154 35.446154 0 0 1-20.716308-6.656l64.630154-64.630154h454.971077a35.643077 35.643077 0 0 1 0 71.286154z m-606.523077-142.454154a71.404308 71.404308 0 0 1-70.498462-71.207385V228.627692A71.325538 71.325538 0 0 1 150.055385 157.380923h605.144615L149.346462 763.155692z m713.491692 0H372.145231L930.107077 205.627077a70.892308 70.892308 0 0 1 3.938461 23.394461v463.281231a71.325538 71.325538 0 0 1-71.364923 71.010462z",
    fill: "rgb(243, 247, 255)",
    "p-id": 8405,
    transform: "scale(0.5) translate(530 530)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenCloseNote);
export default __webpack_public_path__ + "static/media/ScreenCloseNote.273d1237b6b88ad1170ef1258adb8bc5.svg";
export { ForwardRef as ReactComponent };